import { useContext, useEffect } from 'react';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import useSiteInitializedState from 'hooks/useSiteInitializedState';
import { SponsoredAdvert } from 'models/SponsoredAdvert';
import api from 'api';
import utils from 'utils';

export default function useSponsoredListings(dependency: string) {
  const [sponsoredAdvert, setSponsoredAdvert] =
    useSiteInitializedState<SponsoredAdvert>('left-rail-spons');
  const [rightRailAd, setRightRailAD] =
    useSiteInitializedState<SponsoredAdvert>('right-rail-spons');

  const { popServerError } = useContext(PopNotificationsContext);

  useEffect(() => {
    !utils.isSSGHuman() &&
      (async () => {
        try {
          const {
            data: { sponsoredListingMedRec, sponsoredListingStripAd },
          } = await api.sponsoredListings.getSponsoredAdvertPublic();

          setRightRailAD(sponsoredListingMedRec);
          setSponsoredAdvert(sponsoredListingStripAd);
        } catch (e) {
          popServerError(e);
        }
      })();
  }, [dependency, popServerError, setRightRailAD, setSponsoredAdvert]);

  return {
    sponsoredAdvert,
    rightRailAd,
  };
}
